// extracted by mini-css-extract-plugin
export var bodySections = "_d3-8";
export var gray = "_d3-7";
export var green = "_d3-4";
export var iconContainer = "_d3-9";
export var iconWidgetContainer = "_d3-1";
export var phoneIcon = "_d3-2";
export var red = "_d3-5";
export var statusDot = "_d3-3";
export var widgetContainer = "_d3-0";
export var yellow = "_d3-6";